
import { ReactComponent as Svg } from './MorphCloud.svg'

const Logo = () => {
    return <a className={'euiHeaderLogo euiHeader--dark'} style={{backgroundColor: 'transparent'}} href={'/'}><Svg height={32} width={32}/> <span
        className={'euiHeaderLogo__text'}>Morph Cloud</span></a>
}

export default Logo